
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

export const useLinkedStartup = (content: string) => {
  const [linkedStartup, setLinkedStartup] = useState<{
    id: string;
    name: string;
    banner_url?: string;
    short_description?: string;
  } | null>(null);

  useEffect(() => {
    const fetchLinkedStartup = async () => {
      // Check for startup mentions in the format $startupName
      const startupMentionMatch = content.match(/\$(\w+)/);
      
      if (startupMentionMatch) {
        const startupName = startupMentionMatch[1];
        
        const { data, error } = await supabase
          .from("startups")
          .select("id, name, banner_url, short_description")
          .ilike("name", startupName)
          .limit(1);
        
        if (error) {
          console.error("Error fetching linked startup:", error);
          return;
        }
        
        if (data && data.length > 0) {
          setLinkedStartup(data[0]);
        } else {
          setLinkedStartup(null);
        }
      } else {
        setLinkedStartup(null);
      }
    };
    
    fetchLinkedStartup();
  }, [content]);
  
  return { linkedStartup };
};
